export default __webpack_public_path__ + "static/windui-avatars-promo-twitter-b7e4a6483bc2c1defb588a9bcd4b47af.png";